<template>
  <article class="m-card-element m-card-element-design-3">
    <div class="m-card-element-info-data">
      <div
        v-if="!showVideo"
        class="m-card-element-design-3-video"
        @click.prevent="playVideo"
        >
        <img
          v-if="producto.metadata.url_thumbnail"
          :alt="producto.nombre"
          :src="producto.metadata.url_thumbnail"
        >
        <img
          v-else
          :alt="producto.nombre"
          src="@/assets/img/ds3.png"
        >
        <i
          v-if="producto.metadata.url_thumbnail"
          class="far fa-play-circle m-card-element-design-3-icon"
        >
        </i>
      </div>
      <iframe
        v-else
        :id="producto.metadata.url_video"
        :src="videoUrlParsed"
      >
      </iframe>
      <h5>
        {{ producto.categoria.nombre }}
      </h5>
      <h2 class="m-card-element-design-3-name">
        {{ producto.nombre }}
      </h2>
    </div>
    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="producto.activo"
          key="available"
        >
          DISPONIBLE
        </h3>
        <h3
          v-else
          key="notAvailable"
        >
          NO DISPONIBLE
        </h3>
        <h4
          v-if="producto.visible"
          key="visible"
        >
          VISIBLE
        </h4>
        <h4
          v-else
          key="hidden"
        >
          OCULTO
        </h4>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingAcademyProductCard3',
  props: {
    producto: Object
  },

  data () {
    return {
      showVideo: false
    }
  },
  computed: {
    videoUrlParsed () {
      return this.$utils.parseVideo(this.producto.metadata.url_video, true)
    }
  },

  methods: {
    playVideo () {
      if (this.producto.metadata.url_video.length) {
        this.showVideo = true

        setTimeout(() => {
          document.getElementById(this.producto.metadata.url_video).src += '&autoplay=1'
        }, 1200)
      }
    }
  }
}
</script>
